<template>
  <div v-on:click="onClick"  v-if="!url" v-bind:class="`button${buttonClass ? ` ${buttonClass}` : ''}`">
    <slot />
  </div>
  <a v-if="url" v-bind:href="url" v-bind:class="`button${buttonClass ? ` ${buttonClass}` : ''}`">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'Button',
  props: {
    buttonClass: String,
    url: String,
    onClick: Function,
  }
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  padding: 10px 10px 11px 10px;
  background-color: $damiGrass;
  color: $baliBlue;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bold;
  font-size: 15px;
  line-height: 150%;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background-color: rgba($damiGrass, 0.9);
  }
}

a.button {
  text-decoration: none;
}
</style>
